import { Theme, Typography } from '@mui/material';
import { FC } from 'react';
import { NavLink } from 'react-router-dom';
import { makeStyles } from 'tss-react/mui';
import {
  SupplyChainConnector,
  SupplyChainItemType,
} from '../supplychain-types';
import SupplyChainConnectorLayout from './SupplyChainConnectorLayout';
import SupplyChainConnectorsMore from './SupplyChainConnectorsMore';
import SupplyChainConnectorsRenderer from './SupplyChainConnectorsRenderer';

const SupplyChainElementConnectors: FC<SupplyChainElementConnectorsProps> = ({
  showCustomIcon,
  headerLabel,
  headerLink,
  footerLabel,
  footerLink,
  connectors,
  className,
}) => {
  const { classes } = useStyles();

  return (
    <div className={className}>
      <div className={classes.elementBg}>
        <Typography
          variant='body2'
          color='text.primary'
          className={classes.elementHeader}
          component={headerLink ? NavLink : 'p'}
          to={headerLink || ''}>
          {headerLabel}
        </Typography>

        <SupplyChainConnectorLayout
          more={<SupplyChainConnectorsMore connectors={connectors} />}>
          {connectors && (
            <SupplyChainConnectorsRenderer
              connectors={connectors}
              showCustomIcon={!!showCustomIcon}
              type={SupplyChainItemType.Element}
            />
          )}
        </SupplyChainConnectorLayout>

        <Typography
          component={footerLink ? NavLink : 'p'}
          to={footerLink || ''}
          variant='body2'
          fontWeight={400}
          color='text.primary'
          className={classes.elementFooter}>
          {footerLabel}
        </Typography>
      </div>
    </div>
  );
};

const offset = 30;
const useStyles = makeStyles()((theme: Theme) => ({
  elementBg: {
    border: `2px solid ${theme.palette.primary.light}`,
    borderRadius: 5,
    position: 'relative',
    top: -offset,
    background: theme.palette.background.paper,
    height: `calc(100% + ${(offset / 3) * 2}px)`,
    textAlign: 'center',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    paddingBlock: theme.spacing(1),
  },
  container: {
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
  },
  connectors: {
    paddingBlock: theme.spacing(1),
    flexGrow: 1,
    display: 'flex',
    flexDirection: 'column',
  },
  elementHeader: {
    width: '100%',
    lineHeight: 1.2,
    margin: '0 auto',
    minHeight: 30,
    paddingInline: theme.spacing(1),
    wordBreak: 'break-word',
  },
  elementFooter: {
    width: '100%',
    paddingInline: theme.spacing(2),
    lineHeight: 1.2,
  },
}));

export interface SupplyChainElementConnectorsProps {
  headerLabel: string;
  headerLink?: string;
  footerLabel?: string;
  footerLink?: string;
  connectors?: SupplyChainConnector[];
  showCustomIcon: boolean;
  className: string;
}

export default SupplyChainElementConnectors;
